module.exports = __webpack_public_path__ + "static/media/YB5M11_2.19e676eb.jpg";